module.exports = __webpack_public_path__ + "img/DSC_0006.NEF.2f60f644.jpg";